import { render, staticRenderFns } from "./LuckDeliveryForm.vue?vue&type=template&id=0db05c91&scoped=true"
import script from "./LuckDeliveryForm.vue?vue&type=script&lang=js"
export * from "./LuckDeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./LuckDeliveryForm.vue?vue&type=style&index=0&id=0db05c91&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db05c91",
  null
  
)

export default component.exports